import { USER_OWNED_FULL_LICENSE_PRODUCTS_RECEIVE } from '../constants';

export const receive = (userOwnedFullLicenseProducts) => ({
    type: USER_OWNED_FULL_LICENSE_PRODUCTS_RECEIVE,
    payload: userOwnedFullLicenseProducts,
});